"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _keys = _interopRequireDefault(require("lodash/keys"));
var _map = _interopRequireDefault(require("lodash/map"));
var _apis = require("../session/apis");
var _apis2 = require("./apis");
var _actions = require("../notification/actions");
var _selectors = require("../entities/selectors");
var _types = require("./types");
var _selectors2 = require("../session/selectors");
var _middlewares = require("../network/middlewares");
var _api = require("../../utils/api");
var _constants = require("./constants");
var _types2 = require("../session/types");
var _constants2 = require("../app/constants");
var _actions2 = require("../session/actions");
var _selectors3 = require("./selectors");
var _schemas = require("./schemas");
var _types3 = require("../websocket/types");
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var logger = new _logger.default('saga:user');
function* handleWsPutUser(action) {
  var user = action.payload;
  yield* (0, _api.normalizeApiResponse)([user], [_schemas.user]);
  var {
    id,
    settings
  } = yield (0, _effects.select)(_selectors2.userSessionSelector);
  if (id === user.id) {
    var _user$settings;
    if (user !== null && user !== void 0 && (_user$settings = user.settings) !== null && _user$settings !== void 0 && _user$settings.language && user.settings.language !== (settings === null || settings === void 0 ? void 0 : settings.lang)) {
      _i18n.default.setI18nConfig(user.settings.language);
    }
    yield (0, _effects.put)((0, _actions2.setUser)(action.payload));
  }
}
function* getMeLogic() {
  logger.info('getMeLogic launched');
  try {
    var isAuthenticated = yield (0, _effects.select)(_selectors2.userLogged);
    if (isAuthenticated) {
      var _user$settings2;
      var {
        data: user
      } = yield (0, _effects.call)(_apis.$getMe);
      _errorHandler.default.setTag('_user', user.id);
      yield (0, _effects.put)((0, _actions2.setUser)(user));
      yield* (0, _api.normalizeApiResponse)([user], [_schemas.user]);
      if ((_user$settings2 = user.settings) !== null && _user$settings2 !== void 0 && _user$settings2.language) _i18n.default.setI18nConfig(user.settings.language);
      var {
        _company = _config.default.id
      } = user;
      if (_company) {
        var {
          data: companyInfo
        } = yield (0, _effects.call)(_apis.$getCompany, _company);
        yield (0, _effects.put)((0, _actions2.setCompany)(companyInfo));
      }
    }
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function getUsers(_ref) {
  var {
    _users,
    shouldCheckPresenceBeforeFetch
  } = _ref;
  return function* () {
    try {
      var _usersToFetch = new Set(_users);
      if (shouldCheckPresenceBeforeFetch) {
        var {
          users
        } = yield (0, _effects.select)(_selectors.entitiesSelector);
        var _usersEntities = (0, _keys.default)(users);
        _usersEntities.forEach(id => {
          if (_usersToFetch.has(id)) _usersToFetch.delete(id);
        });
      }
      if (_usersToFetch.size) {
        var {
          data
        } = yield (0, _effects.call)(_apis2.$getUsers, [..._usersToFetch]);
        yield* (0, _api.normalizeApiResponse)(data, [_schemas.user]);
      }
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'U1',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function postUserConnectedStatus(_ref2) {
  var {
    payload
  } = _ref2;
  return function* () {
    var usersToUpdate = [];
    var users = yield (0, _effects.select)(_selectors3.userEntitiesSelector);
    var _myUser = yield (0, _effects.select)(_selectors2.getUserId);
    (0, _map.default)(users, _ref3 => {
      var {
        id,
        status
      } = _ref3;
      var expectedStatus = !(0, _isNil.default)(payload[id]) ? payload[id] : _constants.PRESENCE_STATUS.DISCONNECTED;
      if (_myUser !== id && status !== expectedStatus) {
        usersToUpdate.push({
          id,
          status: expectedStatus
        });
      }
    });
    yield* (0, _api.normalizeApiResponse)(usersToUpdate, [_schemas.user]);
  }();
}
function updateUserConnectedStatus(_ref4) {
  var {
    payload
  } = _ref4;
  return function* () {
    var usersToUpdate = (0, _map.default)(payload, (status, id) => ({
      id,
      status
    }));
    yield* (0, _api.normalizeApiResponse)(usersToUpdate, [_schemas.user]);
  }();
}
function putDisconnected(_ref5) {
  var {
    payload
  } = _ref5;
  return function* () {
    var userToUpdate = {
      id: payload,
      status: _constants.PRESENCE_STATUS.DISCONNECTED
    };
    yield* (0, _api.normalizeApiResponse)([userToUpdate], [_schemas.user]);
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)(_types.WS_PUT_USER, handleWsPutUser), (0, _sagas.takeLatest)(_types.GET_USERS, getUsers), (0, _sagas.throttle)(_constants2.sagasTiming, [_types3.WS_CONNECT, _types2.REQUEST_LOGIN_SUCCESS], getMeLogic), (0, _sagas.takeLatest)(_types.WS_POST_CONNECTED, postUserConnectedStatus), (0, _sagas.takeEvery)([_types.WS_PUT_CONNECTED, _types.WS_UPDATE_STATUS], updateUserConnectedStatus), (0, _sagas.takeEvery)(_types.WS_PUT_DISCONNECTED, putDisconnected)]);
}
module.exports = exports.default;